<template>
    <div v-if="upcoming.length" class="toast-top toast-center mx-auto px-4 md:px-20">
        <div v-for="(period, index) in upcoming" :key="index" class="alert alert-success mb-2">
            <div class="flex justify-between w-100" style="width: 100%">
                <div>
                    Foglalási időszak {{ period.name }}: {{ period.starts_at }}-tól
                    {{ period.ends_at }}-ig
                </div>
                <div
                    @click="closeUpcomingPeriod(period)"
                    class="cursor-pointer fill-base-content text-base-100"
                >
                    <CloseIcon/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CloseIcon from '../svg/CloseIcon';

export default {
    name: 'UpcomingPeriods',
    components: { CloseIcon },
    computed: {
        ...mapGetters('Period', ['upcoming']),
    },
    methods: {
        ...mapActions('Period', ['getUpcomingPeriodAsync', 'closeUpcomingPeriod']),
    },
    mounted() {
        this.getUpcomingPeriodAsync();
    },
};
</script>

<style scoped></style>
